import layouts from '~/locales/languages/layouts/kk'

export default defineI18nLocale(() => {
  return {
    ...layouts,
  }
})
